// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  Query = 1,
  Assignment = 2,
  Identifier = 3,
  Filter = 7,
  TagFilter = 8,
  Tag = 9,
  TextFilter = 10,
  String = 11,
  TypeFilter = 12,
  TypeKeyword = 13,
  PropertyFilter = 15,
  PropertyPath = 16,
  Value = 18,
  Number = 19,
  Boolean = 20,
  Null = 21,
  ObjectLiteral = 22,
  ObjectProperty = 24,
  ArrayLiteral = 27,
  Not = 30,
  And = 31,
  Or = 32,
  Relation = 33,
  ArrowRight = 34,
  ArrowLeft = 35
